import { render, staticRenderFns } from "./VozvratFirma.vue?vue&type=template&id=61a56f26&scoped=true&"
import script from "./VozvratFirma.vue?vue&type=script&lang=js&"
export * from "./VozvratFirma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a56f26",
  null
  
)

export default component.exports